import React, { useEffect, useState } from 'react'
import DatePickerHandle from '../../components/Onboard/OnboardComponents/KeyboardDatePicker';
import { OnboardSelect } from '../../components/Onboard/OnboardComponents/Dropdown/Select';
import AdminBreadcrumb from '../../components/Administration/General/Admin-breadcrumb';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Filter_Icon from './../../assets/images/Filter_Icon.png';
import { useDispatch, useSelector } from 'react-redux';
import { getAquaaIcedAccounts, getAquaaIcedAgents, getAquaaIcedTableData, getAquaaValidFromData } from '../../actions/Applications/aquaa.action';

const IcedUpdate = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const aquaaValidFrom = useSelector((state) => state.aquaaReducer.aquaaValidFrom);
  const aquaaIcedAgents = useSelector((state) => state.aquaaReducer.aquaaIcedAgents);
  const aquaaIcedAccounts = useSelector((state) => state.aquaaReducer.aquaaIcedAccounts);
  const aquaaIcedTableData = useSelector((state) => state.aquaaReducer.aquaaIcedTableData);

  console.log('aquaaIcedTableData',aquaaIcedTableData)

  const [isRefreshClicked, setIsRefreshedClicked] = useState(false); 
  const [selectedAgent, setSelectedAgent] = useState();
  const [selectedAccount, setSelectedAccount] = useState();
  const [formData, setFormData] = useState({
                ticketNo: ''
              });

  useEffect(()=>{
    dispatch(getAquaaValidFromData());
    dispatch(getAquaaIcedAgents());
    dispatch(getAquaaIcedAccounts())
  },[dispatch])

  // useEffect(()=>{
  // dispatch(getAquaaIcedTableData(selectedDate.From, selectedDate.To,'','',''));
  // })

   useEffect(() => {
    // Reset the states when the component is mounted
    setSelectedAgent('');
    setSelectedAccount('');
    setFormData({ ticketNo: '' });
    dispatch(getAquaaIcedTableData('', '', '', '', '')); // Reset table data
  }, [dispatch]);
  
  

   function formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();
    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [month, day, year].join('/');
  }

  const [selectedDate, setSelectedDate] = useState(() => {
    const fromDateString = aquaaValidFrom?.[0]?.fromDate;
    return {
      From: fromDateString ? formatDate(new Date(fromDateString)) : null,
      To: formatDate(new Date())
    };
  });
  useEffect(() => {
    const fromDateString = aquaaValidFrom?.[0]?.fromDate;
    if (fromDateString) {
      setSelectedDate(prev => ({
        ...prev,
        From: formatDate(new Date(fromDateString))
      }));
    }
  }, [aquaaValidFrom]);
  
  const FromDateHandler = (date) => {
    setSelectedDate({...selectedDate, From: (date === null || date === undefined) ? null : formatDate(date)});
    
  }
  
  const ToDateHandler = (date) => {
    setSelectedDate({...selectedDate, To: (date === null || date === undefined) ? null : formatDate(date)});
    
  }

   const handleFormDataChange = (key, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [key]: value, // Update specific key in formData
    }));
  };





  
       
  const aquaaIcedData = aquaaIcedTableData && aquaaIcedTableData.length > 0 ? (aquaaIcedTableData) : [];
  

  const tableHeaders = aquaaIcedTableData.length > 0 
  ? Object.keys(aquaaIcedTableData[0]).filter(header => 
      !['AgentID', 'AccountID', 'Ipaddress'].includes(header)
    )
  : [];


  const handleRowClick = (row) => {
    // Navigate to the EvaluationDetail page and pass the selected row data
    history.push({
      pathname: `/icedSubmit`,
      state: { rowData: row }
    });
  };

 const selectedAgentfordispatch = selectedAgent === null || selectedAgent === undefined ? '' : selectedAgent;
 const selectedAccountfordispatch = selectedAccount?.AccountID === null || selectedAccount?.AccountID === undefined ? '' : selectedAccount?.AccountID;


  console.log('selectedaccount',selectedAccount?.AccountID)
  return (
     <div>
          <AdminBreadcrumb value1={()=>history.push('/applications')} label1='Applications' isActive2={true} value2={()=>history.push('/aquaaapplications')} label2='AQuAA' isActive3={false} label3='AQuAA - ICED'/>

      <section className='App_Layout'>
       <main className='Title_bar'> <div className='Applications_Title'> AQuAA - ICED </div>
       </main>
      </section>
      <section className='Filter_aquaa'>
        <main className='aquaa_filter_img'>
          <img src={Filter_Icon} alt='' style={{ padding: '20px', paddingTop: '30px', paddingLeft: '30px' }} />
        </main>
        <div className='aquaaFilterAlignment'>
        <main className='Aquaa_dropdown' style={{width:'142px'}}>
            <DatePickerHandle  label='From' id='label'  value={(selectedDate?.From === undefined || selectedDate?.From === null) ? null : selectedDate?.From}
            onChange={(date) => FromDateHandler(date)} />
          </main>
          <main className='Aquaa_dropdown' style={{width:'142px'}}>
            <DatePickerHandle  label='To' id='label' value={(selectedDate?.To === undefined || selectedDate?.To === null) ? null : selectedDate?.To}
            onChange={(date) => ToDateHandler(date)}  />
          </main>
         
          
          <main className='Aquaa_dropdown'>
            <label HtmlFor='country'>Agent</label>
            <OnboardSelect data={aquaaIcedAgents} name='agent' value='agent Email' id='Id' 
              editValue='' addValueToQueue={(name, selectedValue) => {
          setSelectedAgent(selectedValue)
          setIsRefreshedClicked(false); 
        }} refresh={isRefreshClicked} />
          </main>
          <main className='Aquaa_dropdown'>
            <label HtmlFor='username'>Account</label>
            <OnboardSelect data={aquaaIcedAccounts} name='account' value='Account Name' id='AccountID' passFullObject={true}
              editValue='' addValueToQueue={(name, value) => { setSelectedAccount(value); setIsRefreshedClicked(false) }} refresh={isRefreshClicked} />
          </main>
          <main className='container-two' style={{width:'100px'}}>
            <div><label>Ticket No.</label></div> 
                        <input
                        style={{marginTop:'-10px'}}
                          type="text"
                          placeholder="Example: 0123456789"
                          value={formData.ticketNo}
                          onChange={(e) => handleFormDataChange('ticketNo', e.target.value)}  // Bind to formData.ticketNumber
                        />
                      </main>
          
          
          <button className='btn_adduser' style={{width:'85px'}}
          onClick={() => {
            dispatch(getAquaaIcedTableData(selectedDate.From, selectedDate.To,selectedAgentfordispatch,selectedAccountfordispatch,formData.ticketNo));
          }}
          >LOAD</button>
        </div>
      </section>

      <div className="aquaa-table-container" style={{marginTop:'20px'}}>
              <table className="aquaa-table">
                <thead>
                  <tr>
                    {tableHeaders.map((col, index) => (
                      <th key={index}>{col}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {aquaaIcedData && aquaaIcedData.length > 0 ? (
                    aquaaIcedData.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {tableHeaders.map((col, colIndex) => {
                          const cellData = row[col]; // Get the data for this column in the current row
      
                          if (col === 'Start Date' || col === 'End Date') {
                            return <td key={colIndex}>{new Date(cellData).toLocaleDateString()}</td>; // Format date
                          }
      
                          return (
                            <td key={colIndex} style={col === 'Sid' ? { cursor: 'pointer', color: '#004aac' } : null}>
                              {col === 'Sid' ? <div onClick={() => handleRowClick(row)}>{cellData}</div> : (cellData)}
                            </td>
                          );
                        })}
                      </tr>
                    ))
                  ) : (
                    <tr>
                     <td colSpan={tableHeaders.length + 1}>
                        <section>
                          <div className="noData-para" style={{ marginTop: 0 }}>
                            <div style={{ marginTop: 30 }}>
                              No data available, please try different filters or contact the admin.
                            </div>
                          </div>
                        </section>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
    </div>
  )
}

export default IcedUpdate